module.exports = __webpack_public_path__ + "static/media/process-flow-image.12bbb429.jpg";